var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgListWhite = function SvgListWhite(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 25,
    viewBox: "0 0 19 25",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.252686 3.68011V24.4801C0.252686 24.701 0.431783 24.8801 0.652729 24.8801H15.8528C16.0735 24.8801 16.2526 24.701 16.2526 24.4801V7.68022C16.2526 7.67132 16.2483 7.66374 16.2475 7.65501C16.2455 7.61991 16.2386 7.58531 16.2271 7.5522C16.2226 7.53934 16.2195 7.52699 16.2139 7.51447C16.1945 7.47097 16.1674 7.43126 16.1338 7.39732L12.1339 3.39737C12.0999 3.3636 12.0601 3.33658 12.0163 3.3173C12.0042 3.31219 11.992 3.30791 11.9795 3.30412C11.9461 3.29258 11.9113 3.28566 11.8759 3.28336C11.8691 3.28451 11.8612 3.28023 11.8528 3.28023H0.652729C0.431783 3.28023 0.252686 3.45916 0.252686 3.68011ZM14.8871 7.28017H12.2527V4.64578L14.8871 7.28017ZM1.05261 4.08015H11.4528V7.68022C11.4528 7.901 11.6319 8.0801 11.8526 8.0801H15.4527V24.0802H1.05261V4.08015Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0527 21.6801V22.48H18.2527C18.4736 22.48 18.6527 22.3011 18.6527 22.0801V1.28017C18.6527 1.05922 18.4736 0.880127 18.2527 0.880127H3.05263C2.83168 0.880127 2.65259 1.05922 2.65259 1.28017V2.48014H3.45268V1.68005H17.8526V21.6801H17.0527Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.45264 8.88019H13.0525V9.68011H3.45264V8.88019Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.45264 6.48009H6.65266V7.28018H3.45264V6.48009Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.45264 11.2801H9.85268V12.0802H3.45264V11.2801Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6526 11.2801H13.0525V12.0802H10.6526V11.2801Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3.45264 13.6801H13.0525V14.4801H3.45264V13.6801Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M3.45264 18.4801H13.0525V19.2802H3.45264V18.4801Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M7.05249 16.0802H13.0525V16.8801H7.05249V16.0802Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M3.45264 16.0802H6.25261V16.8801H3.45264V16.0802Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M3.45264 20.8802H5.05265V21.6801H3.45264V20.8802Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M5.85254 20.8802H13.0525V21.6801H5.85254V20.8802Z",
    fill: "white"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgListWhite, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/list-white.94a5e3f1.svg";
export { ForwardRef as ReactComponent };